import React, { memo } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CountryInfoCard = memo(function CountryInfoCard({ focusedCountry }) {
  return (
    <AnimatePresence>
      {focusedCountry && (
        <motion.div
          key={focusedCountry.countryCode}
          initial={{ opacity: 0, x: -12 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -12 }}
          transition={{ duration: 0.2 }}
          className="absolute top-4 left-4 z-50 pointer-events-none"
        >
          <div className="bg-[#1A1B2E]/95 backdrop-blur-md border border-[#E5B978]/40 rounded-xl px-4 py-3 shadow-2xl min-w-[175px]">
            <p className="text-sm font-bold text-[#E5B978] mb-0.5">
              {focusedCountry.country}
            </p>
            <p className="text-xs text-white/50 mb-3">
              {focusedCountry.count.toLocaleString()} total users
            </p>
            <div className="space-y-1.5">
              <p className="text-[9px] text-white/35 font-semibold uppercase tracking-wider mb-1">
                By region
              </p>
              {focusedCountry.states.map((s) => (
                <div
                  key={s.name}
                  className="flex items-center justify-between gap-6"
                >
                  <span className="text-xs text-white/70 flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block flex-shrink-0" />
                    {s.name}
                  </span>
                  <span className="text-xs text-[#E5B978] font-semibold tabular-nums">
                    {s.count.toLocaleString()}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default CountryInfoCard;
